module.exports = __webpack_public_path__ + "img/banner.efb63e3c.png";